/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your exact age`)
};

const es_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra tu edad exacta`)
};

const de_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie Ihr genaues Alter`)
};

const nl_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind uw exacte leeftijd`)
};

const fr_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez votre âge exact`)
};

const it_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova la tua età esatta`)
};

const pt_br2_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre sua idade exata`)
};

const pt_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a sua idade exata`)
};

const ja_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確な年齢を検索`)
};

const zh_age_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算您的精确年龄`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_nav_main_desc", locale)
	if (locale === "en") return en_age_nav_main_desc(inputs)
	if (locale === "es") return es_age_nav_main_desc(inputs)
	if (locale === "de") return de_age_nav_main_desc(inputs)
	if (locale === "nl") return nl_age_nav_main_desc(inputs)
	if (locale === "fr") return fr_age_nav_main_desc(inputs)
	if (locale === "it") return it_age_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_age_nav_main_desc(inputs)
	if (locale === "pt") return pt_age_nav_main_desc(inputs)
	if (locale === "ja") return ja_age_nav_main_desc(inputs)
	return zh_age_nav_main_desc(inputs)
};